import Guid from "@/app/types/common/guid";
import type { BrewManApiError } from "@/app/errors";

export type ResponseInterceptor = (
  err: BrewManApiError | undefined,
  fetchResponse: Response,
  responseData: any,
  context: {
    userFriendlyServiceName: string;
    preAsyncStackTrace: string;
    requestStartTimeMsSinceEpoch: number;
    isDbWrite: boolean;
  }
) => [BrewManApiError | undefined, any];

export class ApiSettings {
  public sessionToken: string | null = null;
  public tenantId: Guid = Guid.createEmpty();
  public tenantGroupId: Guid = Guid.createEmpty();
  public responseInterceptors: ResponseInterceptor[] = [];
}

export default new ApiSettings();
